import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import ContactForm, { ContactFormData } from '@amf/shared/components/contact/ContactForm';

import { ButtonProps } from '../button/Button';

const defaultValues: ContactFormData = {
  name: '',
  email: '',
  phone: '',
  message: '',
};

interface ContactSendProps {
  buttonProps?: ButtonProps;
}

export default function ContactSend({ buttonProps }: ContactSendProps) {
  const { t } = useTranslate();
  const [error, setError] = useState<string | undefined>(undefined);
  const [success, setSuccess] = useState(false);

  const send = async (data: ContactFormData & { recaptchaToken: string }) => {
    setError(undefined);
    setSuccess(false);

    const response = await fetch('/api/contact', {
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    const result = (await response.json()) as {
      success?: boolean;
      error?: string;
    };

    if (result.error) {
      setError(result.error);
      return;
    }

    if (result.success) {
      setSuccess(true);
    }
  };

  if (success) {
    return (
      <div className='ContactPage__form ContactPage__form--center'>
        <h2>{t('contact.form.success.title')}</h2>
        <p className='ContactPage__formMessage'>{t('contact.form.success.message')}</p>
      </div>
    );
  }

  return (
    <div>
      {error && (
        <div className='Error' style={{ minHeight: 0, paddingTop: 16, paddingBottom: 16 }}>
          <p className='Error__title' style={{ margin: 0 }}>
            {error}
          </p>
        </div>
      )}
      <ContactForm onSubmit={send} values={defaultValues} buttonProps={buttonProps} />
    </div>
  );
}
